import React, { useEffect, useState } from "react";
import {
  Route,
  BrowserRouter as Router,
  Routes as Switch,
  Navigate,
} from "react-router-dom";
import LoginPage from "./Pages/LoginPage";
import DashboardPage from "./Pages/Dashboard";
import SuperProvider from "./Context/SuperProvider";
import ForgotPassword from "./Pages/ForgotPassword";
import ErrorPage from "./Pages/ErrorPage";
import RegisterUserPage from "./Components/users/RegisterUserPage";
import ViewUserPage from "./Components/users/ViewUserPage";
import UserProfile from "./Components/users/USerProfile";
import PermissionsDistribution from "./Components/users/PermissionsDistribution";
import UserPermissionsDistribution from "./Components/users/UserPermissionsDistribution";
import UserRoles from "./Components/users/UserRoles";
import RolePermissionsDistribution from "./Components/users/RolePermissionsDistribution";
import functions from "./util/functions";
import ViewFuelStationOwners from "./Components/stationOwners/ViewFuelStationOwners";
import ViewFuelStation from "./Components/stations/ViewFuelStation";
import ViewFuelStationGroups from "./Components/stationsGroups/ViewFuelStationGroups";
import ViewFuelCategories from "./Components/fuelCategories/ViewFuelCategories";
import ViewFuelTanks from "./Components/fuelTanks/ViewFuelTanks";
import ViewFuelPumps from "./Components/fuelPumps/ViewFuelPumps";
import ViewFuelPrices from "./Components/fuelPrices/ViewFuelPrices";
import ViewShiftTemplates from "./Components/shiftTempalets/ViewShiftTemplates";
import ViewCompanyLevelUsers from "./Components/users/ViewCompanyLevelUsers";
import ViewShiftAllocation from "./Components/Shifts/ViewShiftAllocation";
import StartEmployeeShift from "./Components/Attendence/StartEmployeeShift";
import ViewActiveAttendenceSessions from "./Components/Attendence/ViewActiveAttendenceSessions";
import ViewSuppliers from "./Components/suppliers/ViewSuppliers";
import ViewFuelDeliveries from "./Components/deliveries/ViewFuelDeliveries";
import ViewStationRecentSales from "./Components/Sales/ViewStationRecentSales";
import MonthlyAttendantSales from "./Components/Sales/MonthlyAttendantSales";
import ActivateAccount from "./Pages/ActivateAccount";
import toast, { Toaster } from "react-hot-toast";
import SingleStationInventoryMonthlyFlow from "./Components/Inventory/SingleStationInventoryMonthlyFlow";
function App(props) {
  const [loggedIn, setLoggedIn] = useState(true);
  function checkLogin() {
    if (!window.localStorage.getItem("FuelFy@daisy")) {
      setLoggedIn(false);
    } else {
      setLoggedIn(true);
    }
  }
  useEffect(() => {
    checkLogin();
  }, []);
  const logoutUser = () => {
    setLoggedIn(false);
    localStorage.removeItem("FuelFy@daisy");
    window.location.reload();
  };
  useEffect(() => {
    let logoutTimer;
    const startLogoutTimer = () => {
      logoutTimer = setTimeout(() => {
        logoutUser();
        toast.error("You have been logged out due to inactivity.");
      }, 1200000); // 20 minutes in milliseconds
    };
    const resetTimer = () => {
      clearTimeout(logoutTimer);
      startLogoutTimer();
    };
    startLogoutTimer();
    const activityEvents = ["mousemove", "keydown", "click"];
    activityEvents.forEach((event) =>
      window.addEventListener(event, resetTimer)
    );
    return () => {
      activityEvents.forEach((event) =>
        window.removeEventListener(event, resetTimer)
      );
      clearTimeout(logoutTimer);
    };
  }, []);
  const secure = functions.checkSecureAccount();
  return (
    <SuperProvider>
      <Toaster />
      <Router forceRefresh={false}>
        <Switch>
          {!loggedIn && (
            <>
              <Route path="*" element={<LoginPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/Activate/account" element={<ActivateAccount />} />
              <Route
                path="/password_rest/forgot"
                element={<ForgotPassword />}
              />
              <Route
                path="/"
                element={
                  !loggedIn ? (
                    <Navigate replace to="/login" />
                  ) : (
                    <DashboardPage />
                  )
                }
              />
            </>
          )}
          {loggedIn && !secure && (
            <>
              <Route path="/Activate/account" element={<ActivateAccount />} />
              <Route
                path="/"
                element={<Navigate replace to="/Activate/account" />}
              />
            </>
          )}
          {loggedIn && secure && (
            <>
              <Route
                path="/"
                element={
                  !loggedIn ? (
                    <Navigate replace to="/login" />
                  ) : (
                    <DashboardPage />
                  )
                }
              />
              <Route path="/" element={<DashboardPage />} />
              <Route path="/poultry_Dshboard" element={<DashboardPage />} />
              <Route path="*" element={<ErrorPage />} />
              {/* fuel station groups */}
              <Route
                path="fuel_station_Groups/groups_page"
                element={<ViewFuelStationGroups />}
              />
              {/* station_owners management */}
              <Route
                path="/fuel_station_owners/view"
                element={<ViewFuelStationOwners />}
              />
              {/* stations */}
              <Route
                path="/fuel_stations/view_fuel_stations"
                element={<ViewFuelStation />}
              />
              {/* fuel_categories */}
              <Route
                path="/fuel_categories/fuel_categories_page"
                element={<ViewFuelCategories />}
              />
              {/* fuel Tanks */}
              <Route
                path="/fuel_tanks/fuel_tanks_page"
                element={<ViewFuelTanks />}
              />
              {/* fuel pumps */}
              <Route
                path="/fuel_pumps/fuel_pumps_page"
                element={<ViewFuelPumps />}
              />
              <Route path="/fuel_suppliers/view" element={<ViewSuppliers />} />
              <Route
                path="/deliveries/view_deliveries"
                element={<ViewFuelDeliveries />}
              />
              <Route
                path="/sales/view_recent_sales"
                element={<ViewStationRecentSales />}
              />
              <Route
                path="/sales/monthly_attendant_sales"
                element={<MonthlyAttendantSales />}
              />
              <Route
                path="/inventory/month_inventory_flow"
                element={<SingleStationInventoryMonthlyFlow />}
              />
              {/* fuel prices */}
              <Route
                path="/fuel_prices/fuel_prices_page"
                element={<ViewFuelPrices />}
              />
              {/* shifts */}
              <Route
                path="/shifts/shift_templates"
                element={<ViewShiftTemplates />}
              />
              <Route
                path="/shift/View_shift_allocations"
                element={<ViewShiftAllocation />}
              />
              <Route
                path="/attendence/sign_inn_attendant"
                element={<StartEmployeeShift />}
              />
              <Route
                path="/attendence/active_sessions"
                element={<ViewActiveAttendenceSessions />}
              />
              {/* User managements*/}
              <Route
                path="/login"
                element={loggedIn ? <Navigate replace to="/" /> : <LoginPage />}
              />
              <Route
                path="/users/register_newbie"
                element={<RegisterUserPage />}
              />
              <Route
                path="/station_users/View_users"
                element={<ViewUserPage />}
              />
              <Route
                path="/comapny_users/view"
                element={<ViewCompanyLevelUsers />}
              />
              <Route path="/user/profile" element={<UserProfile />} />
              <Route
                path="/users/permissions"
                element={<PermissionsDistribution />}
              />
              <Route
                path="/user/permissions/:userID"
                element={<UserPermissionsDistribution />}
              />
              <Route path="/users/roles" element={<UserRoles />} />
              <Route
                path="/users/roles/permissions/:role_id"
                element={<RolePermissionsDistribution />}
              />
            </>
          )}
        </Switch>
      </Router>
    </SuperProvider>
  );
}
export default App;
